import { render, staticRenderFns } from "./VmForm.vue?vue&type=template&id=12268278&scoped=true&"
import script from "./VmForm.vue?vue&type=script&lang=js&"
export * from "./VmForm.vue?vue&type=script&lang=js&"
import style0 from "./VmForm.vue?vue&type=style&index=0&id=12268278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12268278",
  null
  
)

export default component.exports